import { render, staticRenderFns } from "./keyword-analysis.vue?vue&type=template&id=0bb3b9da&scoped=true&"
import script from "./keyword-analysis.vue?vue&type=script&lang=js&"
export * from "./keyword-analysis.vue?vue&type=script&lang=js&"
import style0 from "./keyword-analysis.vue?vue&type=style&index=0&id=0bb3b9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3b9da",
  null
  
)

export default component.exports